import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=1a231307&scoped=true&"
import script from "./CategoryFilters.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=1a231307&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a231307",
  null
  
)

export default component.exports